import {
  GET_NOTIFICATION_PREFERENCES_LOADING,
  GET_NOTIFICATION_PREFERENCES_SUCCESS,
  GET_NOTIFICATION_PREFERENCES_ERROR,
  UPDATE_NOTIFICATION_PREFERENCES_LOADING,
  UPDATE_NOTIFICATION_PREFERENCES_SUCCESS,
  UPDATE_NOTIFICATION_PREFERENCES_ERROR,
  UPDATE_QUIET_HOURS_LOADING,
  UPDATE_QUIET_HOURS_SUCCESS,
  UPDATE_QUIET_HOURS_ERROR,
  UPDATE_DIGEST_PREFERENCES_LOADING,
  UPDATE_DIGEST_PREFERENCES_SUCCESS,
  UPDATE_DIGEST_PREFERENCES_ERROR,
  GET_CHANNEL_SUBSCRIPTIONS_LOADING,
  GET_CHANNEL_SUBSCRIPTIONS_SUCCESS,
  GET_CHANNEL_SUBSCRIPTIONS_ERROR,
  SUBSCRIBE_TO_CHANNEL_LOADING,
  SUBSCRIBE_TO_CHANNEL_SUCCESS,
  SUBSCRIBE_TO_CHANNEL_ERROR,
  UNSUBSCRIBE_FROM_CHANNEL_LOADING,
  UNSUBSCRIBE_FROM_CHANNEL_SUCCESS,
  UNSUBSCRIBE_FROM_CHANNEL_ERROR,
  MUTE_CHANNEL_LOADING,
  MUTE_CHANNEL_SUCCESS,
  MUTE_CHANNEL_ERROR,
  UNMUTE_CHANNEL_LOADING,
  UNMUTE_CHANNEL_SUCCESS,
  UNMUTE_CHANNEL_ERROR,
  GET_POST_SUBSCRIPTIONS_LOADING,
  GET_POST_SUBSCRIPTIONS_SUCCESS,
  GET_POST_SUBSCRIPTIONS_ERROR,
  SUBSCRIBE_TO_POST_LOADING,
  SUBSCRIBE_TO_POST_SUCCESS,
  SUBSCRIBE_TO_POST_ERROR,
  UNSUBSCRIBE_FROM_POST_LOADING,
  UNSUBSCRIBE_FROM_POST_SUCCESS,
  UNSUBSCRIBE_FROM_POST_ERROR,
  MUTE_POST_LOADING,
  MUTE_POST_SUCCESS,
  MUTE_POST_ERROR,
  UNMUTE_POST_LOADING,
  UNMUTE_POST_SUCCESS,
  UNMUTE_POST_ERROR,
  GET_COMMUNITY_POLICY_LOADING,
  GET_COMMUNITY_POLICY_SUCCESS,
  GET_COMMUNITY_POLICY_ERROR,
  UPDATE_COMMUNITY_POLICY_LOADING,
  UPDATE_COMMUNITY_POLICY_SUCCESS,
  UPDATE_COMMUNITY_POLICY_ERROR,
  GET_CHANNEL_POLICY_LOADING,
  GET_CHANNEL_POLICY_SUCCESS,
  GET_CHANNEL_POLICY_ERROR,
  UPDATE_CHANNEL_POLICY_LOADING,
  UPDATE_CHANNEL_POLICY_SUCCESS,
  UPDATE_CHANNEL_POLICY_ERROR,
} from '../actions/notificationSettingsActions';
import {
  INotificationPreference,
  IUserChannelSubscription,
  IUserPostSubscription,
  ICommunityNotificationPolicy,
  IChannelNotificationPolicy,
} from '../../api/notificationSettings';

export interface INotificationSettingsState {
  // User Preferences
  preferences: INotificationPreference | null;
  preferencesLoading: boolean;
  preferencesError: string | null;

  // Channel Subscriptions
  channelSubscriptions: IUserChannelSubscription[];
  channelSubscriptionsLoading: boolean;
  channelSubscriptionsError: string | null;

  // Post Subscriptions
  postSubscriptions: IUserPostSubscription[];
  postSubscriptionsLoading: boolean;
  postSubscriptionsError: string | null;

  // Community Policy (Admin)
  communityPolicy: ICommunityNotificationPolicy | null;
  communityPolicyLoading: boolean;
  communityPolicyError: string | null;

  // Channel Policy (Admin)
  channelPolicy: IChannelNotificationPolicy | null;
  channelPolicyLoading: boolean;
  channelPolicyError: string | null;

  // Operation Loading States
  updatePreferencesLoading: boolean;
  updateQuietHoursLoading: boolean;
  updateDigestPreferencesLoading: boolean;
  subscribeToChannelLoading: boolean;
  unsubscribeFromChannelLoading: boolean;
  muteChannelLoading: boolean;
  unmuteChannelLoading: boolean;
  subscribeToPostLoading: boolean;
  unsubscribeFromPostLoading: boolean;
  mutePostLoading: boolean;
  unmutePostLoading: boolean;
  updateCommunityPolicyLoading: boolean;
  updateChannelPolicyLoading: boolean;
}

const initialState: INotificationSettingsState = {
  preferences: null,
  preferencesLoading: false,
  preferencesError: null,

  channelSubscriptions: [],
  channelSubscriptionsLoading: false,
  channelSubscriptionsError: null,

  postSubscriptions: [],
  postSubscriptionsLoading: false,
  postSubscriptionsError: null,

  communityPolicy: null,
  communityPolicyLoading: false,
  communityPolicyError: null,

  channelPolicy: null,
  channelPolicyLoading: false,
  channelPolicyError: null,

  updatePreferencesLoading: false,
  updateQuietHoursLoading: false,
  updateDigestPreferencesLoading: false,
  subscribeToChannelLoading: false,
  unsubscribeFromChannelLoading: false,
  muteChannelLoading: false,
  unmuteChannelLoading: false,
  subscribeToPostLoading: false,
  unsubscribeFromPostLoading: false,
  mutePostLoading: false,
  unmutePostLoading: false,
  updateCommunityPolicyLoading: false,
  updateChannelPolicyLoading: false,
};

export default function notificationSettingsReducer(
  state = initialState,
  action: any
): INotificationSettingsState {
  switch (action.type) {
    // ========== User Preferences ==========

    case GET_NOTIFICATION_PREFERENCES_LOADING:
      return {
        ...state,
        preferencesLoading: true,
        preferencesError: null,
      };

    case GET_NOTIFICATION_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.payload,
        preferencesLoading: false,
        preferencesError: null,
      };

    case GET_NOTIFICATION_PREFERENCES_ERROR:
      return {
        ...state,
        preferencesLoading: false,
        preferencesError: action.payload,
      };

    case UPDATE_NOTIFICATION_PREFERENCES_LOADING:
      return {
        ...state,
        updatePreferencesLoading: true,
        preferencesError: null,
      };

    case UPDATE_NOTIFICATION_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.payload,
        updatePreferencesLoading: false,
        preferencesError: null,
      };

    case UPDATE_NOTIFICATION_PREFERENCES_ERROR:
      return {
        ...state,
        updatePreferencesLoading: false,
        preferencesError: action.payload,
      };

    case UPDATE_QUIET_HOURS_LOADING:
      return {
        ...state,
        updateQuietHoursLoading: true,
        preferencesError: null,
      };

    case UPDATE_QUIET_HOURS_SUCCESS:
      return {
        ...state,
        preferences: action.payload,
        updateQuietHoursLoading: false,
        preferencesError: null,
      };

    case UPDATE_QUIET_HOURS_ERROR:
      return {
        ...state,
        updateQuietHoursLoading: false,
        preferencesError: action.payload,
      };

    case UPDATE_DIGEST_PREFERENCES_LOADING:
      return {
        ...state,
        updateDigestPreferencesLoading: true,
        preferencesError: null,
      };

    case UPDATE_DIGEST_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.payload,
        updateDigestPreferencesLoading: false,
        preferencesError: null,
      };

    case UPDATE_DIGEST_PREFERENCES_ERROR:
      return {
        ...state,
        updateDigestPreferencesLoading: false,
        preferencesError: action.payload,
      };

    // ========== Channel Subscriptions ==========

    case GET_CHANNEL_SUBSCRIPTIONS_LOADING:
      return {
        ...state,
        channelSubscriptionsLoading: true,
        channelSubscriptionsError: null,
      };

    case GET_CHANNEL_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        channelSubscriptions: action.payload,
        channelSubscriptionsLoading: false,
        channelSubscriptionsError: null,
      };

    case GET_CHANNEL_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        channelSubscriptionsLoading: false,
        channelSubscriptionsError: action.payload,
      };

    case SUBSCRIBE_TO_CHANNEL_LOADING:
      return {
        ...state,
        subscribeToChannelLoading: true,
        channelSubscriptionsError: null,
      };

    case SUBSCRIBE_TO_CHANNEL_SUCCESS: {
      const newSubscription = action.payload;
      const existingIndex = state.channelSubscriptions.findIndex(
        (sub) =>
          sub.communityIdentifier === newSubscription.communityIdentifier &&
          sub.channelIdentifier === newSubscription.channelIdentifier
      );

      const updatedSubscriptions =
        existingIndex >= 0
          ? state.channelSubscriptions.map((sub, idx) =>
              idx === existingIndex ? newSubscription : sub
            )
          : [...state.channelSubscriptions, newSubscription];

      return {
        ...state,
        channelSubscriptions: updatedSubscriptions,
        subscribeToChannelLoading: false,
        channelSubscriptionsError: null,
      };
    }

    case SUBSCRIBE_TO_CHANNEL_ERROR:
      return {
        ...state,
        subscribeToChannelLoading: false,
        channelSubscriptionsError: action.payload,
      };

    case UNSUBSCRIBE_FROM_CHANNEL_LOADING:
      return {
        ...state,
        unsubscribeFromChannelLoading: true,
        channelSubscriptionsError: null,
      };

    case UNSUBSCRIBE_FROM_CHANNEL_SUCCESS: {
      const { communityIdentifier, channelIdentifier } = action.payload;
      return {
        ...state,
        channelSubscriptions: state.channelSubscriptions.filter(
          (sub) =>
            !(
              sub.communityIdentifier === communityIdentifier &&
              sub.channelIdentifier === channelIdentifier
            )
        ),
        unsubscribeFromChannelLoading: false,
        channelSubscriptionsError: null,
      };
    }

    case UNSUBSCRIBE_FROM_CHANNEL_ERROR:
      return {
        ...state,
        unsubscribeFromChannelLoading: false,
        channelSubscriptionsError: action.payload,
      };

    case MUTE_CHANNEL_LOADING:
      return {
        ...state,
        muteChannelLoading: true,
        channelSubscriptionsError: null,
      };

    case MUTE_CHANNEL_SUCCESS: {
      const mutedSubscription = action.payload;
      return {
        ...state,
        channelSubscriptions: state.channelSubscriptions.map((sub) =>
          sub.communityIdentifier === mutedSubscription.communityIdentifier &&
          sub.channelIdentifier === mutedSubscription.channelIdentifier
            ? mutedSubscription
            : sub
        ),
        muteChannelLoading: false,
        channelSubscriptionsError: null,
      };
    }

    case MUTE_CHANNEL_ERROR:
      return {
        ...state,
        muteChannelLoading: false,
        channelSubscriptionsError: action.payload,
      };

    case UNMUTE_CHANNEL_LOADING:
      return {
        ...state,
        unmuteChannelLoading: true,
        channelSubscriptionsError: null,
      };

    case UNMUTE_CHANNEL_SUCCESS: {
      const unmutedSubscription = action.payload;
      return {
        ...state,
        channelSubscriptions: state.channelSubscriptions.map((sub) =>
          sub.communityIdentifier === unmutedSubscription.communityIdentifier &&
          sub.channelIdentifier === unmutedSubscription.channelIdentifier
            ? unmutedSubscription
            : sub
        ),
        unmuteChannelLoading: false,
        channelSubscriptionsError: null,
      };
    }

    case UNMUTE_CHANNEL_ERROR:
      return {
        ...state,
        unmuteChannelLoading: false,
        channelSubscriptionsError: action.payload,
      };

    // ========== Post Subscriptions ==========

    case GET_POST_SUBSCRIPTIONS_LOADING:
      return {
        ...state,
        postSubscriptionsLoading: true,
        postSubscriptionsError: null,
      };

    case GET_POST_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        postSubscriptions: action.payload,
        postSubscriptionsLoading: false,
        postSubscriptionsError: null,
      };

    case GET_POST_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        postSubscriptionsLoading: false,
        postSubscriptionsError: action.payload,
      };

    case SUBSCRIBE_TO_POST_LOADING:
      return {
        ...state,
        subscribeToPostLoading: true,
        postSubscriptionsError: null,
      };

    case SUBSCRIBE_TO_POST_SUCCESS: {
      const newSubscription = action.payload;
      const existingIndex = state.postSubscriptions.findIndex(
        (sub) => sub.postId === newSubscription.postId
      );

      const updatedSubscriptions =
        existingIndex >= 0
          ? state.postSubscriptions.map((sub, idx) =>
              idx === existingIndex ? newSubscription : sub
            )
          : [...state.postSubscriptions, newSubscription];

      return {
        ...state,
        postSubscriptions: updatedSubscriptions,
        subscribeToPostLoading: false,
        postSubscriptionsError: null,
      };
    }

    case SUBSCRIBE_TO_POST_ERROR:
      return {
        ...state,
        subscribeToPostLoading: false,
        postSubscriptionsError: action.payload,
      };

    case UNSUBSCRIBE_FROM_POST_LOADING:
      return {
        ...state,
        unsubscribeFromPostLoading: true,
        postSubscriptionsError: null,
      };

    case UNSUBSCRIBE_FROM_POST_SUCCESS: {
      const { postId } = action.payload;
      return {
        ...state,
        postSubscriptions: state.postSubscriptions.filter((sub) => sub.postId !== postId),
        unsubscribeFromPostLoading: false,
        postSubscriptionsError: null,
      };
    }

    case UNSUBSCRIBE_FROM_POST_ERROR:
      return {
        ...state,
        unsubscribeFromPostLoading: false,
        postSubscriptionsError: action.payload,
      };

    case MUTE_POST_LOADING:
      return {
        ...state,
        mutePostLoading: true,
        postSubscriptionsError: null,
      };

    case MUTE_POST_SUCCESS: {
      const mutedSubscription = action.payload;
      return {
        ...state,
        postSubscriptions: state.postSubscriptions.map((sub) =>
          sub.postId === mutedSubscription.postId ? mutedSubscription : sub
        ),
        mutePostLoading: false,
        postSubscriptionsError: null,
      };
    }

    case MUTE_POST_ERROR:
      return {
        ...state,
        mutePostLoading: false,
        postSubscriptionsError: action.payload,
      };

    case UNMUTE_POST_LOADING:
      return {
        ...state,
        unmutePostLoading: true,
        postSubscriptionsError: null,
      };

    case UNMUTE_POST_SUCCESS: {
      const unmutedSubscription = action.payload;
      return {
        ...state,
        postSubscriptions: state.postSubscriptions.map((sub) =>
          sub.postId === unmutedSubscription.postId ? unmutedSubscription : sub
        ),
        unmutePostLoading: false,
        postSubscriptionsError: null,
      };
    }

    case UNMUTE_POST_ERROR:
      return {
        ...state,
        unmutePostLoading: false,
        postSubscriptionsError: action.payload,
      };

    // ========== Admin: Community Policy ==========

    case GET_COMMUNITY_POLICY_LOADING:
      return {
        ...state,
        communityPolicyLoading: true,
        communityPolicyError: null,
      };

    case GET_COMMUNITY_POLICY_SUCCESS:
      return {
        ...state,
        communityPolicy: action.payload,
        communityPolicyLoading: false,
        communityPolicyError: null,
      };

    case GET_COMMUNITY_POLICY_ERROR:
      return {
        ...state,
        communityPolicyLoading: false,
        communityPolicyError: action.payload,
      };

    case UPDATE_COMMUNITY_POLICY_LOADING:
      return {
        ...state,
        updateCommunityPolicyLoading: true,
        communityPolicyError: null,
      };

    case UPDATE_COMMUNITY_POLICY_SUCCESS:
      return {
        ...state,
        communityPolicy: action.payload,
        updateCommunityPolicyLoading: false,
        communityPolicyError: null,
      };

    case UPDATE_COMMUNITY_POLICY_ERROR:
      return {
        ...state,
        updateCommunityPolicyLoading: false,
        communityPolicyError: action.payload,
      };

    // ========== Admin: Channel Policy ==========

    case GET_CHANNEL_POLICY_LOADING:
      return {
        ...state,
        channelPolicyLoading: true,
        channelPolicyError: null,
      };

    case GET_CHANNEL_POLICY_SUCCESS:
      return {
        ...state,
        channelPolicy: action.payload,
        channelPolicyLoading: false,
        channelPolicyError: null,
      };

    case GET_CHANNEL_POLICY_ERROR:
      return {
        ...state,
        channelPolicyLoading: false,
        channelPolicyError: action.payload,
      };

    case UPDATE_CHANNEL_POLICY_LOADING:
      return {
        ...state,
        updateChannelPolicyLoading: true,
        channelPolicyError: null,
      };

    case UPDATE_CHANNEL_POLICY_SUCCESS:
      return {
        ...state,
        channelPolicy: action.payload,
        updateChannelPolicyLoading: false,
        channelPolicyError: null,
      };

    case UPDATE_CHANNEL_POLICY_ERROR:
      return {
        ...state,
        updateChannelPolicyLoading: false,
        channelPolicyError: action.payload,
      };

    default:
      return state;
  }
}
